/**
 * handles.js
 * 
 * Imperative handles for working with the storage worker
 * 
 **/
import { messages } from './messages.js'
import PocketBase from 'pocketbase'

/**
 * @function usePocketBaseAuth
 * 
 * @param {MessageChannelPort} port
 * 
 * Workers can't share auth across `localStorage`, this forwards it to their port.
 * 
 **/
const forwardAuthorization = (backend, port) => {
  const pb = new PocketBase(backend)

  if (pb.authStore.isValid) {
    const { record, token } = pb.authStore
    port.postMessage({ type: messages.AUTH_UPDATED, record, token })
  }

  pb.authStore.onChange((record, token) => {
    port.postMessage({ type: messages.AUTH_UPDATED, record, token })
  })
}

/**
 * @function initializeWorker
 * 
 * @param {Worker} worker
 * 
 * Asynchronously initializes the worker and passes its returned port to the caller
 *
 **/
const initializeWorker = async (worker) => {
  return new Promise((resolve, reject) => {
    worker.addEventListener('message', (event) => {
      const { data, origin } = event
      const { type, port } = data

      if (type === messages.WORKER_READY) {
        resolve(port)
      } else {
        reject("Did not receive worker ready response")
      }
    }, { once: true })
  })
}

export { forwardAuthorization, initializeWorker }